import * as yup from 'yup';

const withoutEmployeeId = text => ({
  is: value => value == null,
  then: yup.string().required(text)
});

export const validations = yup.object().shape({
  employeeId: yup
    .number()
    .nullable(),
  name: yup
    .string()
    .required('O nome é obrigatório'),
  status: yup
    .number()
    .required('O status é obrigatório'),
  email: yup
    .string()
    .transform(email => email?.replace(/ /g, ''))
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório'),
  establishmentUuid: yup
    .string()
    .required('Escolha o estabelecimento para vincular'),
  password: yup
    .string()
    .when('employeeId', withoutEmployeeId('A senha é obrigatória'))
    .test('password-min-length', 'Mínimo de 8 caracteres', function(password) {
      if(!password) {
        return true;
      }

      return password.length >= 8;
    }),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) => password ? schema.required('Confirme a senha') : schema)
    .oneOf([yup.ref('password'), null], 'A senha e a confirmação devem ser iguais')
});
